import { useTranslation } from 'react-i18next'

import DatePicker from '@/common/components/DatePicker/DatePicker'

import * as Styles from './styles'

const DateRangeInput = ({ value, onChange, disabled }) => {
  const { t } = useTranslation()

  return (
    <Styles.DateRow>
      <DatePicker
        value={value?.startDate || null}
        onChange={date => onChange({ ...value, startDate: date })}
        label={t('Fecha de inicio')}
        disabled={disabled}
        fullWidth
        clearable
      />
      <DatePicker
        value={value?.endDate || null}
        onChange={date => onChange({ ...value, endDate: date })}
        label={t('Fecha de fin')}
        disabled={disabled}
        fullWidth
        clearable
      />
    </Styles.DateRow>
  )
}

export default DateRangeInput
